import { Formik } from 'formik';
import React, { useState } from 'react'
import RegularButton from '../../components/Buttons/RegularButton';
import Header from '../../components/Header/Header';
import * as Yup from "yup";
import screen1 from '../../assets/screen1.png';
import { Rating, TextField } from '@mui/material';
import DatePicker from 'react-datepicker';
import { useSaveCustomerFeedbackMutation } from '../../redux/services/feedbackApi';

type Props = {}

const feedBackSchema = Yup.object().shape({
    comment: Yup.string().max(20).required(' Comment is required'),
});

const FeedBack = (props: Props) => {
    const currentUser: any = JSON.parse(localStorage.getItem('user') || '{}');
    const userToken: string = currentUser?.jwtToken;
    const [startDate, setStartDate] = useState(null);
    const [saveFeedback, saveFeedbackResponse] = useSaveCustomerFeedbackMutation();
    const [ratingValue, setRatingValue] = React.useState(0);
    const [formValues, setFormValues] = useState({
        comment: "",
        rating: 0,
    });

    const handleSubmitForm = async (values: any, action: any) => {
        saveFeedback({
            payload: {
                customerId: currentUser.customerId,
                rating: ratingValue,
                comments: values.comment,
                date: new Date(),
                id: 433,
                merchantId: currentUser.merchantId,
                serviceProviderId: 70
            },
            token: userToken
        })

        action.resetForm();
    };
    return (
        <div>
            <div className="h-[75px] mx-10">
                <Header position={'fixed'} isLoggedIn={userToken ? true : false} />
            </div>

            <div
                style={{
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div
                    className="container"
                    style={{
                        backgroundColor: '#fff',

                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div className="lg:flex flex-row md:flex items-center justify-center h-full md:h-[500px] bg-[#F5FAFF] w-10/12 rounded-lg md:p-10 my-10">
                        <div className="p-3 lg:w-[600px] ">
                            <div className="">
                                <h1 className="text-black md:text-4xl text-[22px] font-medium mb-5">
                                    Customer <span className="text-blue-500">Feed Back</span>
                                </h1>
                                <p className="text-black text-lg mb-5"></p>
                            </div>

                            <Formik
                                enableReinitialize
                                initialValues={formValues}
                                onSubmit={handleSubmitForm}
                                validationSchema={feedBackSchema}
                            >
                                {({ handleBlur, handleChange, handleSubmit, values, touched, errors }) => (
                                    <>
                                        <div className="items-center mt-5">
                                            <div className="w-full mr-5">

                                                <div className="flex items-center w-full md:w-[400px]  mt-2 bg-white ">
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                        id={'outlined-multiline-static'}
                                                        name={'comment'}
                                                        value={values.comment}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Your Comment"
                                                        multiline
                                                        rows={2}
                                                        maxRows={4}
                                                        className="rounded border-2 border-blue-500 w-full font-bold"
                                                        error={Boolean(touched.comment && errors.comment)}
                                                        helperText={touched.comment && errors.comment}
                                                    />
                                                </div>
                                            </div>
                                            <div className="w-full">
                                                <div className="flex w-[150px] mt-5">
                                                    <Rating
                                                        precision={1}
                                                        size={"large"}
                                                        value={ratingValue}
                                                        onChange={(newValue: any) => {
                                                            setRatingValue(newValue.target.value);
                                                        }}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="mt-10  text-center"
                                            onClick={() => { }}
                                            style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                            }}
                                        >
                                            <RegularButton
                                                className="rounded-full font-medium w-[400px] h-[60px] text-[20px]"
                                                title="Submit"
                                                onClick={() => {
                                                    handleSubmit();
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </Formik>
                        </div>
                        <div
                            className="lg:w-[600px]"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <img src={screen1} alt="s1" className="w-3/4 rounded-2xl hidden sm:block" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeedBack